/**
 *
 * Login
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import img from "images/brand/Mandu_white.svg"
import { Helmet } from "react-helmet"
import { isEqual, get } from "lodash"
import { message } from "antd"
import { Icon } from "@ant-design/compatible"
import makeSelectLogin, {
  makeSelectError,
  makeSelectErrorMessage,
  makeSelectErrorExceed,
  makeSelectLoading,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"
import {
  loginWatcher,
  loginReset,
  loginCompanyWatcher,
  loginFailed,
  loginProofIntegrated,
} from "./actions"
import LoginComponent from "../../components/LoginComponent"
import PageLogo from "../../components/PageLogo"
import { LoadingOutlined } from "@ant-design/icons"
import {
  LOCAL_MODULES,
  setItem,
  KEY_ACTIVE_ROL,
  KEY_AMBASSADOR_ID,
  KEY_CHECKBOX_EXCLUDE,
  KEY_COMPANY_ID,
  KEY_COMPANY_LOGO,
  KEY_COMPANY_NAME,
  KEY_DASHBOARD_BIRTHDAY_CHECK,
  KEY_EMPLOYEE_ID,
  KEY_ISOLATED_METRICS,
  KEY_MODULES,
  KEY_ONBOARDING,
  KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER,
  KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
  KEY_ORGANIZATION_DIVISIONS_FILTER,
  KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
  KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER,
  KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER,
  KEY_TOKEN,
  KEY_TRANSFER_USER,
  KEY_TRIAL_ACTIVE,
  KEY_TRIAL_DURATION,
  KEY_TRIAL_END_DATE,
  KEY_TRIAL_MAX_COLLABORATORS,
  KEY_TRIAL_START_DATE,
  KEY_USER_EMAIL,
  KEY_USER_ID,
  KEY_USER_NAME,
  KEY_USER_PHOTO,
  KEY_USER_ROLES,
  KEY_USER_ROLES_TEXT,
  LOCAL_TOKEN,
  KEY_LOGIN_LANGUAGE,
  SHOWED_FEEDBACK_SURVEY,
  KEY_FEATURE_FLAGS,
  KEY_COMPANY_HUBSPOT,
  KEY_COMPANY_COUNTRY,
  KEY_COMPANY_SUPPORT_CHANNEL,
  KEY_PDA_IA_ENABLED,
  KEY_NEW_PDA_IA_NOTIFICATION,
  KEY_VISMA_PEOPLE_SYNC_ENABLED
} from "../../utils/storage"
import { hideSurvicateWidget } from "../../utils/survicate"
import { hasAnalyticsConsent } from "../../utils/cookieyes"
import { ROLES_ADMIN_MANDU } from "../../utils/constants"
import { validate } from "../../utils/functions"
import { history, push } from "connected-react-router"
import { LanguageSelector } from "../../components/LanguageSelector"
import Loader from "../../components/Loader"
/* eslint-disable react/prefer-stateless-function */
export class Login extends React.Component {
  state = {
    isLoadingComponent: true,
    iframeLoader: false,
    logoInit: "",
  }

  loaderComponent = null

  UNSAFE_componentWillMount = () => {
    this.setState({ logoInit: "logo_loading_animated" })
    if (this.props.location.search) {
      const queryString = window.queryString(this.props.location.search)
      if (queryString.token && queryString.token.length > 0) {
        this.redirectLoginWithJWTasQueryParameter()
      }
      if (queryString.admin && queryString.admin.length > 0) {
        this.redirectLoginWithJWTasQueryParameterAdmin()
      }
      if (queryString.language && queryString.language.length > 0) {
        setItem(KEY_LOGIN_LANGUAGE, queryString.language)
      }
      if (queryString.notFound) {
        message.error(
          "El usuario no se encuentra registrado en la plataforma"
        )
      } else {
        if(queryString.tk){
          //const tokenFromCompany = this.props.location.search.replace("?tk=", "")
         // this.props.loginCompany({ token: queryString.tk })
        }

      }
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(this.props.login.isLoggedIn, prevProps.login.isLoggedIn)) {
      const {
        push,
        location: { state },
      } = this.props.history
      if (validRole({ role: [1, 2, 3, 4] })) {

        if (!this.props.login.isTwoFactorAuthEnabled || LOCAL_TOKEN() != null) {
          push("/organization")
        } else {
          push("/two_factor_authentication")
        }
        /*
        if (typeof window.fcWidget !== 'undefined'){
         // window.fcWidget.open()
        }
        */
      } else {
        if (!this.props.login.isTwoFactorAuthEnabled || LOCAL_TOKEN() != null) {
          const modules = JSON.parse(LOCAL_MODULES())

          let dashboardModule = modules.find((mod) => mod.slug === "dashboard")
          if (dashboardModule?.mode === "disable") push("/reports")
          else push("/") // default dashboard
        } else {
          push("/two_factor_authentication")
        }
      }

    }
  }

  componentDidMount = () => {
    // Ocultar chat de Intercom en la vista de login
    if (typeof window.Intercom !== 'undefined') {
      window.Intercom('shutdown')
    }
    // Oculta el widget de Survicate si está presente
    hideSurvicateWidget()

    this.loaderComponent = setTimeout(() => {
      return this.setState({ isLoadingComponent: false })
    }, 2800)

    const {
      match: { params },
    } = this.props

    if(window.top !== window.self) { 
      this.setState({iframeLoader: true})
    }

    const queryString = window.location.search;
    
    let searchParams = new URLSearchParams(queryString);

    if (![undefined, null, ""].includes(params.hash)) {

      let loginProofParams = { hash: params.hash }

      if(searchParams.has("redirectto")) {
        loginProofParams.redirectto = searchParams.get("redirectto")
      }

      if(searchParams.has("hideheader")) {
        loginProofParams.hideheader = searchParams.get("hideheader")
      }

      if(searchParams.has("aiLimitReached")) {
        loginProofParams.aiLimitReached = searchParams.get("aiLimitReached")
      }

      this.props.onLoginProof(loginProofParams)
    }

  }

  componentWillUnmount = () => {
    this.props.loginFailed()
    this.setState({ logoInit: "" })
    clearTimeout(this.loaderComponent)
  }

  redirectLoginWithJWTasQueryParameterAdmin() {

    let data =  this.props.location.search.replace("?admin=", "");
    data = data.replace(/%22/g, '"');
    data = JSON.parse(data).data;

    this.setLocalStorageDataLogin(data)
    // window.initializeChatWidget();
    if (typeof window.fcWidget !== 'undefined') {
      window.fcWidget.show();
    }
    this.generateOnboarding(false)
    // google analytics code — VLENG-11641: sin consentimiento de analítica, no
    // se pushea al dataLayer (evita que GTM lo procese en cuanto cargue)
    if (hasAnalyticsConsent()) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "login",
        userId: data.id,
      })
    }

    if (
      data.modules.length === 0 &&
      ROLES_ADMIN_MANDU.includes(data.active_role)
    ) {
      location.href = "/companies"
    } else {

      this.props.login.isLoggedIn = true
      const {
        push,
        location: { state },
      } = this.props.history
      if (validRole({ role: [1, 2, 3, 4] })) {
        push("/organization")
        /*
        if (typeof window.fcWidget !== 'undefined'){
          window.fcWidget.open()
        }
          */

      } else {
        const modules = JSON.parse(LOCAL_MODULES())

        let dashboardModule = modules.find((mod) => mod.slug === "dashboard")
        if (dashboardModule?.mode === "disable") push("/reports")
        else push("/")
      }

    }
  }

  redirectLoginWithJWTasQueryParameter() {
    let data = JSON.parse(
      decodeURIComponent(this.props.location.search.replace("?token=", ""))
    ).data
    // console.log(data)
    this.setLocalStorageDataLogin(data)
    // window.initializeChatWidget();
    /*
    if (typeof window.fcWidget !== 'undefined') {
      window.fcWidget.show();
      //  window.fcWidget.open();
    }
        */
    this.generateOnboarding(data.onboarding)
    // google analytics code — VLENG-11641: sin consentimiento de analítica, no
    // se pushea al dataLayer (evita que GTM lo procese en cuanto cargue)
    if (hasAnalyticsConsent()) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "login",
        userId: data.id,
      })
    }

    if (
      data.modules.length === 0 &&
      ROLES_ADMIN_MANDU.includes(data.active_role)
    ) {
      location.href = "/companies"
    } else {

      this.props.login.isLoggedIn = true
      const {
        push,
        location: { state },
      } = this.props.history
      if (validRole({ role: [1, 2, 3, 4] })) {
        push("/organization")
        /*
        if (typeof window.fcWidget !== 'undefined'){
          window.fcWidget.open()
        }
        */
      } else {
        const modules = JSON.parse(LOCAL_MODULES())

        let dashboardModule = modules.find((mod) => mod.slug === "dashboard")
        if (dashboardModule?.mode === "disable") push("/reports")
        else push("/")
      }
    }
  }


  showIframeLoader = () => {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#F9F9F9"
        }}>
        <Loader />
      </div>
    )
  }

  showLoader = () => {
    return (
      <div
        style={{
          background:
            "linear-gradient(360deg, rgba(0, 0, 0, 0.2) -2.87%, rgba(255, 255, 255, 0) 78.88%), #2E52F8",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <LoadingOutlined style={{ color: "white", fontSize: 50 }} />
      </div>
    )
  }

  render() {

    if(this.state.iframeLoader) {
      return this.showIframeLoader()
    }

    if (this.state.isLoadingComponent) {
      return this.showLoader()
    }

    return (
      <div>
        <Helmet>
          <title>MandüHr</title>
          <meta name="description" content="Description of OrganizationPage" />
        </Helmet>
        <LanguageSelector/>
        <PageLogo>
          <LoginComponent
            error={this.props.error}
            login={this.props.onLogin}
            loginProof={this.props.onLoginProof}
            errorExceed={this.props.errorExceed}
            errorMessage={this.props.errorMessage}
            img={img}
            reset={this.props.onReset}
            loading={this.props.loading}
          />
        </PageLogo>
      </div>
    )
  }

  setLocalStorageDataLogin(data) {
    let userRolesText = []
    data.roles?.map((row) => userRolesText.push(row.text))
    const company = data.companies
    setItem(SHOWED_FEEDBACK_SURVEY,data.showed_feedback_survey)
    setItem(KEY_USER_ID, data.id)
    setItem(KEY_TRANSFER_USER, data.transfer_user)
    setItem(KEY_USER_PHOTO, data.picture_profile)
    setItem(KEY_USER_NAME, data.name)
    setItem(KEY_USER_EMAIL, data.email)
    setItem(KEY_AMBASSADOR_ID, data.id_ambassador)
    setItem(KEY_EMPLOYEE_ID, data.id_employee)
    setItem(KEY_ACTIVE_ROL, data.active_role)
    setItem(KEY_USER_ROLES, JSON.stringify(data.roles))
    setItem(KEY_USER_ROLES_TEXT, JSON.stringify(userRolesText))
    setItem(KEY_TOKEN, data.access_token)
    setItem(KEY_MODULES, JSON.stringify(data.modules))

    if (validate.exist(data.is_new_pda_ia_notification)) {
      setItem(KEY_NEW_PDA_IA_NOTIFICATION, data.is_new_pda_ia_notification);
    }
    if (validate.exist(company.id_company)) {

      setItem(KEY_COMPANY_ID, company.id_company)
      setItem(KEY_COMPANY_HUBSPOT, company.hubspot_company_id)
      setItem(KEY_COMPANY_COUNTRY, company.country || null)
      setItem(KEY_COMPANY_SUPPORT_CHANNEL, company.support_channel || null)
      setItem(
        KEY_COMPANY_LOGO,
        validate.exist(company.logo) ? company.logo : null
      )
      setItem(KEY_COMPANY_NAME, company.name)
      setItem(KEY_TRIAL_ACTIVE, company.trial_active)
      setItem(KEY_TRIAL_DURATION, company.trial_duration)
      setItem(KEY_TRIAL_END_DATE, company.trial_end_date)
      setItem(KEY_TRIAL_MAX_COLLABORATORS, company.trial_max_collaborators)
      setItem(KEY_TRIAL_START_DATE, company.trial_start_date)
    } else {
      setItem(KEY_COMPANY_ID)
      setItem(KEY_COMPANY_LOGO)
      setItem(KEY_COMPANY_NAME)
      setItem(KEY_COMPANY_SUPPORT_CHANNEL)
      setItem(KEY_TRIAL_ACTIVE)
      setItem(KEY_TRIAL_DURATION)
      setItem(KEY_TRIAL_END_DATE)
      setItem(KEY_TRIAL_MAX_COLLABORATORS)
      setItem(KEY_TRIAL_START_DATE)
      setItem(KEY_COMPANY_HUBSPOT)
      setItem(KEY_COMPANY_COUNTRY)
    }
    setItem(KEY_ORGANIZATION_DIVISIONS_FILTER, JSON.stringify(["ambassadors"]))
    setItem(KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER, "")
    setItem(KEY_DASHBOARD_BIRTHDAY_CHECK, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER, "")
    setItem(
      KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
      JSON.stringify(["email", "division", "segment", "leader", "team"])
    )
    setItem(KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER, JSON.stringify([]))
    setItem(KEY_CHECKBOX_EXCLUDE, false)
    setItem(KEY_ISOLATED_METRICS, false)
    if(validate.exist(data.companies.pdas_ia_enable)){
      setItem(KEY_PDA_IA_ENABLED, data.companies.pdas_ia_enable)
    }
    if(validate.exist(data.companies.visma_people_sync_enabled)){
      setItem(KEY_VISMA_PEOPLE_SYNC_ENABLED, data.companies.visma_people_sync_enabled)
    }
    if(validate.exist(data.companies.feature_flags)){
      setItem(KEY_FEATURE_FLAGS, JSON.stringify(data.companies.feature_flags))
    }

  }



  generateOnboarding(onboarding) {
    if (onboarding === undefined) {
      onboarding = []
    }
    setItem(
      KEY_ONBOARDING,
      Array.isArray(onboarding) ? JSON.stringify(onboarding) : onboarding
    )
  }
}

Login.propTypes = { onLogin: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  login: makeSelectLogin(),
  error: makeSelectError(),
  errorExceed: makeSelectErrorExceed(),
  errorMessage: makeSelectErrorMessage(),
  loading: makeSelectLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (params) => dispatch(loginWatcher(params)),
    onLoginProof: (params) => dispatch(loginProofIntegrated(params)),
    onReset: () => dispatch(loginReset()),
    loginCompany: (params) => dispatch(loginCompanyWatcher(params)),
    loginFailed: (params) => dispatch(loginFailed(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "login", reducer })
const withSaga = injectSaga({ key: "login", saga })

export default compose(withReducer, withSaga, withConnect)(Login)
